module.exports = "pegasus/assets/theme4/medium/7.jpg";